import { cloneDeep } from "lodash-es";
import { getListItemStateMethods } from "../state/scope/ListItemState";
import { IVersionControl } from "../../interfaces/collection/ICollection";
import { addCollectionIdToEntity } from "./addCollectionIdToEntity";
export function getListDataSchema(itemMethods) {
  return function () {
    const listDataSchema = {
      id: 'listData',
      type: 'array',
      title: '列表数据',
      items: {
        type: 'object' // 实体类型
      }
    };

    const entitySchema = this.getEntitySchema();
    if (entitySchema) {
      var _this$options$sourceC;
      const entity = cloneDeep(entitySchema);
      const collectionId = (_this$options$sourceC = this.options.sourceConfig) === null || _this$options$sourceC === void 0 ? void 0 : _this$options$sourceC.collectionId;
      if (collectionId) {
        addCollectionIdToEntity(collectionId, entity);
      }
      if (itemMethods) {
        entity.methods = getListItemStateMethods(this);
      }
      listDataSchema.items = entity;
    }
    // if (this.isJSStateModel) {
    //   listDataSchema['ds:fitDataId'] = FITDATAIDS.listData;
    // }
    return listDataSchema;
  };
}
export function getAllDataSchema() {
  var _this$options$sourceC2;
  if (((_this$options$sourceC2 = this.options.sourceConfig) === null || _this$options$sourceC2 === void 0 ? void 0 : _this$options$sourceC2.usage) !== 'local') {
    return null;
  }
  const listDataSchema = {
    id: 'allData',
    type: 'array',
    title: '全部数据',
    hidden: true,
    items: {
      type: 'object' // 实体类型
    }
  };

  const entitySchema = this.getEntitySchema();
  if (entitySchema) {
    const entity = cloneDeep(entitySchema);
    listDataSchema.items = entity;
  }
  return listDataSchema;
}
export function getSelectedItemsSchema() {
  const selectedItemsSchema = {
    id: 'selectedItems',
    type: 'array',
    title: '已选中的列表项',
    hidden: true,
    items: {
      type: 'object' // 实体类型
    }
  };

  const entitySchema = this.getEntitySchema();
  if (entitySchema) {
    const entity = cloneDeep(entitySchema);
    selectedItemsSchema.items = entity;
  }
  return selectedItemsSchema;
}
export const pageSchema = {
  id: 'page',
  type: 'number',
  title: '页码',
  default: 1
};
export const prodPageSchema = {
  id: 'prodPage',
  type: 'number',
  title: '正式数据页码',
  default: 1,
  hidden: true
};
export const deleteOpPageSchema = {
  id: 'deleteOpPage',
  type: 'number',
  title: '删除记录页码',
  default: 1,
  hidden: true
};
export const historyPageSchema = {
  id: 'historyPage',
  type: 'number',
  title: '历史版本页码',
  default: 1,
  hidden: true
};
export const sizeSchema = {
  id: 'size',
  type: 'number',
  title: '每页数目',
  default: 20
};
export const prodSizeSchema = {
  id: 'prodSize',
  type: 'number',
  title: '正式数据每页数目',
  default: 20,
  hidden: true
};
export const deleteOpSizeSchema = {
  id: 'deleteOpSize',
  type: 'number',
  title: '删除记录每页数目',
  default: 20,
  hidden: true
};
export const historySizeSchema = {
  id: 'historySize',
  type: 'number',
  title: '历史版本每页数目',
  default: 20,
  hidden: true
};
export const includeSchema = {
  id: 'include',
  type: 'string',
  title: '显示字段',
  hidden: true
};
export const excludeSchema = {
  id: 'exclude',
  type: 'string',
  title: '排除字段',
  hidden: true
};
export const totalSchema = {
  id: 'total',
  type: 'number',
  title: '总数'
};
export const prodCountSchema = {
  id: 'prodCount',
  type: 'number',
  title: '正式数据总数',
  default: 0,
  hidden: true
};
export const historyCountSchema = {
  id: 'historyCount',
  type: 'number',
  title: '历史版本总数',
  default: 0,
  hidden: true
};
export const deleteOpCountSchema = {
  id: 'deleteOpCount',
  type: 'number',
  title: '删除记录总数',
  default: 0,
  hidden: true
};
export const publishStatusFilterSchema = {
  id: 'publishStatusFilter',
  type: 'number',
  title: '发布状态筛选参数',
  default: 0,
  enum: [{
    value: 0,
    label: '任意状态'
  }, {
    value: 1,
    label: '已发布'
  }, {
    value: 2,
    label: '未发布'
  }]
};
export function getListDataWithStatusSchema() {
  if (this.collection.collectionData.versionControl === IVersionControl.Row) {
    const listDataWithStatusSchema = {
      id: 'listDataWithStatus',
      type: 'array',
      title: '带发布状态的列表数据',
      items: {
        type: 'object' // 实体类型
      }
    };

    const entitySchema = this.getEntitySchema();
    if (entitySchema) {
      const entity = cloneDeep(entitySchema);
      entity.fields.push({
        default: 1,
        description: '',
        id: '_rv_status',
        isPrimaryKey: false,
        readonly: true,
        title: '发布状态',
        type: 'number',
        enum: [{
          value: 0,
          label: '未知'
        }, {
          value: 1,
          label: '已发布'
        }, {
          value: 2,
          label: '未发布'
        }]
      });
      listDataWithStatusSchema.items = entity;
    }
    return listDataWithStatusSchema;
  }
  return null;
}
export function getProdListDataSchema() {
  if (this.collection.collectionData.versionControl === IVersionControl.Row) {
    const prodListData = {
      id: 'prodListData',
      type: 'array',
      title: '正式表数据',
      items: {
        type: 'object' // 实体类型
      }
    };

    const entitySchema = this.getEntitySchema();
    if (entitySchema) {
      const entity = cloneDeep(entitySchema);
      prodListData.items = entity;
    }
    return prodListData;
  }
  return null;
}
export function getDeleteOpListDataSchema() {
  if (this.collection.collectionData.versionControl === IVersionControl.Row) {
    const deleteOpListDataSchema = {
      id: 'deleteOpListData',
      type: 'array',
      title: '删除记录',
      items: {
        type: 'object',
        fields: [{
          type: 'string',
          title: 'id',
          id: 'id'
        }, {
          type: 'string',
          title: '发布人',
          id: 'operator'
        }, {
          type: 'string',
          title: '原始数据',
          id: 'originData'
        }]
      }
    };
    return deleteOpListDataSchema;
  }
  return null;
}
export function getHistoryListDataSchema() {
  if (this.collection.collectionData.versionControl === IVersionControl.Row) {
    const historypListDataSchema = {
      id: 'historyListData',
      type: 'array',
      title: '历史版本',
      items: {
        type: 'object',
        fields: [{
          type: 'string',
          title: 'id',
          id: 'versionId'
        }, {
          type: 'string',
          title: '创建人',
          id: 'operator'
        }, {
          type: 'string',
          title: '版本描述',
          id: 'desc'
        }, {
          type: 'string',
          title: '版本数据',
          id: 'data'
        }, {
          type: 'number',
          title: '状态',
          id: 'status'
        }, {
          type: 'string',
          title: '创建时间',
          id: '_ctime'
        }]
      }
    };
    return historypListDataSchema;
  }
  return null;
}
//# sourceMappingURL=list.js.map
